<template>
	<form @submit.prevent="onsubmit">
		<va-input
		v-model="email"
		type="email"
		:label="$t('auth.email')"
		:error="!!emailErrors.length"
		:error-messages="emailErrors"
		/>

		<va-input
		v-model="password"
		type="password"
		:label="$t('auth.password')"
		:error="!!passwordErrors.length"
		:error-messages="passwordErrors"
		/>

		<div class="auth-layout__options d-flex align--center justify--space-between">
			<!-- <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/> -->
			<!-- <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link> -->
		</div>

		<div class="d-flex justify--center mt-3">
			<va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
		</div>
	</form>
</template>

<script>
import moment from 'moment';
import jwtClass from 'jsonwebtoken';

export default {
	name: 'login',
	data () {
		return {
			email: '',
			password: '',
			// keepLoggedIn: false,
			emailErrors: [],
			passwordErrors: [],

			toastDuration: 10000,
			toastPosition: 'top-center',
			isToastFullWidth: false,
			className: 'vuestic-toast '
		}
	},
	computed: {
		formReady () {
			return !this.emailErrors.length && !this.passwordErrors.length
		},
	},
	created(){
		this.$store.commit("clearAuth");
		this.$cookies.remove("jwt");
	},
	methods: {
		onsubmit () {
			this.emailErrors = this.email ? [] : [this.$t('auth.requiredField')]
			this.passwordErrors = this.password ? [] : [this.$t('auth.requiredField')]
			if (!this.formReady) {
				this.launchToast(this.$t('auth.loginError'), 'error');
				return
			}

			this.$axios.post('api/users/loginUser',{
				email: this.email,
				password : this.password
			}).then(axRes => {
				var user = jwtClass.decode(axRes.data.jwt);
				if(user.role >= 99){
					var expire = moment(axRes.data.expire).format('X') - moment().format('X');
					this.$cookies.set('jwt', axRes.data.jwt, expire);
					this.$store.commit("setAuth", {jwt : axRes.data.jwt, user: user});
					this.$axios.defaults.headers = {
						Authorization: 'Bearer ' + this.$store.state.auth.jwt
					}
					this.$router.push({ name: 'orders' });
				} else {
					this.launchToast(this.$t('auth.unauthorized'), 'error');
				}
			}).catch(axErr => {
				this.launchToast(this.$t('auth.loginError'), 'error');
			})
		},
		launchToast (text, className) {
			this.showToast(
				text,
				{
					position: this.toastPosition,
					duration: this.toastDuration,
					fullWidth: this.isToastFullWidth,
					className: this.className + className
				},
			)
		},
	},
}
</script>

<style lang="scss">
</style>
